import { render, staticRenderFns } from "./VehicleResult.vue?vue&type=template&id=397fb55e"
import script from "./VehicleResult.vue?vue&type=script&lang=js"
export * from "./VehicleResult.vue?vue&type=script&lang=js"
import style0 from "./VehicleResult.vue?vue&type=style&index=0&id=397fb55e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports